import { render, staticRenderFns } from "./WaiterListOverview.vue?vue&type=template&id=3e5a5c7e&"
import script from "./WaiterListOverview.vue?vue&type=script&lang=js&"
export * from "./WaiterListOverview.vue?vue&type=script&lang=js&"
import style0 from "./WaiterListOverview.vue?vue&type=style&index=0&id=3e5a5c7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports